module.exports = __webpack_public_path__ + "img/customers@2x.d43b2a2f.png";